import apiFetch from './client';

export interface UserMembership {
  id: string;
  condominiumId: string;
  condominiumName: string;
  condominiumSlug: string;
  role: 'MANAGER' | 'USER';
  status: 'ACTIVE' | 'INVITED' | 'SUSPENDED';
  createdAt: string;
  updatedAt: string;
}

export interface UserWithMemberships {
  id: string;
  firebaseUid: string;
  email: string;
  firstName?: string;
  lastName?: string;
  documentNumber?: string;
  phone?: string;
  photoUrl?: string;
  createdAt: string;
  lastLoginAt?: string;
  updatedAt: string;
  memberships: UserMembership[];
}

export async function listUsers(): Promise<UserWithMemberships[]> {
  const data = await apiFetch<UserWithMemberships[]>('/users');
  return data ?? [];
}
